<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
import { useAuthStore } from "@/stores/authStore";
import HrPayrollMark from "@/components/branding/hr-payroll-mark.vue";
export default {
    components: {
        PerfectScrollbar,
        HrPayrollMark,
    },
    setup() {
        const authStore = useAuthStore();
        return { authStore };
    },
    data() {
        return {
            settings: {
                suppressScrollX: true,
            },
            activeClass: "active",
            mobileSidebarOpen: false,
        };
    },
    methods: {
        scrollHanle() {},
        handleMobileSidebarState(event) {
            this.mobileSidebarOpen = !!event?.detail?.open;
        },
        handleSidebarMenuClick(event) {
            if (window.innerWidth >= 992) return;
            const link = event.target?.closest?.("a");
            if (!link) return;
            const href = link.getAttribute("href") || "";
            if (!href || href === "#" || href.startsWith("javascript:")) return;
            this.closeMobileSidebar();
        },
        closeMobileSidebar() {
            document.body.classList.remove("slide-nav", "dq-mobile-drawer-open");
            this.mobileSidebarOpen = false;
            window.dispatchEvent(
                new CustomEvent("dq-mobile-sidebar", {
                    detail: { open: false },
                })
            );
        },
    },
    computed: {
        currentPath() {
            return this.$route.name;
        },
        homeRoute() {
            const roles = this.authStore?.user?.roles || [];
            if (roles.includes("SuperAdmin")) return "/super-admin/dashboard";
            if (
                roles.includes("Client") &&
                !roles.includes("Employee") &&
                !roles.includes("Admin") &&
                !roles.includes("Hr") &&
                !roles.includes("HR")
            ) {
                return "/crm/clients";
            }
            if (
                roles.includes("Employee") &&
                !roles.includes("Admin") &&
                !roles.includes("Hr") &&
                !roles.includes("HR")
            ) {
                return "/dashboard/employee-dashboard";
            }
            return "/dashboard/admin-dashboard";
        },
    },
    mounted() {
        window.addEventListener(
            "dq-mobile-sidebar",
            this.handleMobileSidebarState
        );
    },
    beforeUnmount() {
        window.removeEventListener(
            "dq-mobile-sidebar",
            this.handleMobileSidebarState
        );
    },
};
</script>

<template>
    <!-- Sidebar -->
	<div class="sidebar" id="sidebar">
		<!-- Logo -->
		<div class="sidebar-logo">
			<router-link :to="homeRoute" class="logo logo-normal">
				<hr-payroll-mark variant="sidebar" />
			</router-link>
			<router-link :to="homeRoute" class="logo-small">
				<hr-payroll-mark variant="icon" />
			</router-link>
			<router-link :to="homeRoute" class="dark-logo">
				<hr-payroll-mark variant="sidebar" tone="dark" />
			</router-link>
		</div>
		<!-- /Logo -->
		<div class="modern-profile p-3 pb-0">
			<div class="text-center rounded bg-light p-3 mb-4 user-profile">
				<div class="avatar avatar-lg online mb-3">
					<img src="@/assets/img/profiles/avatar-02.jpg" alt="Img" class="img-fluid rounded-circle">
				</div>
				<h6 class="fs-12 fw-normal mb-1">Adrian Herman</h6>
				<p class="fs-10">System Admin</p>
			</div>
			<div class="sidebar-nav mb-3">
				<ul class="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent"
					role="tablist">
					<li class="nav-item"><a class="nav-link active border-0" href="javascript:void(0);">Menu</a></li>
					<li class="nav-item">
					<router-link class="nav-link border-0" to="/applications/chat"
						>Chats</router-link
					>
					</li>
					<li class="nav-item">
					<router-link class="nav-link border-0" to="/applications/email"
						>Inbox</router-link
					>
					</li>
				</ul>
			</div>
		</div>
		<div class="sidebar-header p-3 pb-0 pt-2">
			<div class="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center">
				<div class="avatar avatar-md onlin">
					<img src="@/assets/img/profiles/avatar-02.jpg" alt="Img" class="img-fluid rounded-circle">
				</div>
				<div class="text-start sidebar-profile-info ms-2">
					<h6 class="fs-12 fw-normal mb-1">Adrian Herman</h6>
					<p class="fs-10">System Admin</p>
				</div>
			</div>
			<div class="input-group input-group-flat d-inline-flex mb-4">
				<span class="input-icon-addon">
					<i class="ti ti-search"></i>
				</span>
				<input type="text" class="form-control" placeholder="Search in HRMS">
				<span class="input-group-text">
					<kbd>CTRL + / </kbd>
				</span>
			</div>
			<div class="d-flex align-items-center justify-content-between menu-item mb-3">
				<div class="me-3">
					<a href="javascript:void(0);" class="btn btn-menubar position-relative">
						<i class="ti ti-shopping-bag"></i>
						<span
							class="badge bg-success rounded-pill d-flex align-items-center justify-content-center header-badge">5</span>
					</a>
				</div>
				<div class="me-3">
					<a href="javascript:void(0);" class="btn btn-menubar">
						<i class="ti ti-layout-grid-remove"></i>
					</a>
				</div>
				<div class="me-3">
					<a href="javascript:void(0);" class="btn btn-menubar position-relative">
						<i class="ti ti-brand-hipchat"></i>
						<span
							class="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge">5</span>
					</a>
				</div>
				<div class="me-3 notification-item">
					<router-link to="/notifications" class="btn btn-menubar position-relative me-1">
						<i class="ti ti-bell"></i>
						<span class="notification-status-dot"></span>
					</router-link>
				</div>
				<div class="me-0">
					<a href="javascript:void(0);" class="btn btn-menubar">
						<i class="ti ti-message"></i>
					</a>
				</div>
			</div>
		</div>
	<div class="sidebar-inner slimscroll">
			<perfect-scrollbar class="scroll-area" :settings="settings" @ps-scroll-y="scrollHanle">
				<div id="sidebar-menu" class="sidebar-menu" @click.capture="handleSidebarMenuClick">
					<sidebar-menu></sidebar-menu>
				</div>
			</perfect-scrollbar>
		</div>
	</div>
	<!-- /Sidebar -->
    <div
        class="sidebar-overlay"
        :class="{ opened: mobileSidebarOpen }"
        @click="closeMobileSidebar"
    ></div>

	<horizontal-header></horizontal-header>
	<two-sidebar></two-sidebar>
	<stacked-sidebar></stacked-sidebar>
</template>

<style scoped>
.sidebar-logo {
	display: flex;
	align-items: flex-end;
	justify-content: flex-start;
	height: 64px;
	padding: 14px 16px 4px;
	box-sizing: border-box;
}

.sidebar-logo :deep(.logo) {
	margin-top: 0;
	display: inline-flex;
	align-items: center;
	max-width: 100%;
	height: 100%;
}

.sidebar-logo :deep(.dark-logo) {
	display: none;
	margin-top: 0;
	align-items: center;
	max-width: 100%;
}

.sidebar-logo :deep(.logo-small) {
	display: inline-flex;
	align-items: center;
}

.sidebar-logo :deep(.dq-brand-mark) {
	height: 100%;
}

.sidebar-logo :deep(.dq-brand-mark__copy) {
	justify-content: center;
}

.sidebar-logo :deep(.dq-brand-mark__eyebrow) {
	display: block;
}

.sidebar-logo :deep(.dq-brand-mark__title) {
	white-space: nowrap;
}

:deep(.slimScrollDiv) {
	top: 64px;
}

:deep(.sidebar-menu) {
	margin-top: 8px;
}
</style>
